"use client";
import * as React from "react";
const SvgBoltSharp = ({
  title,
  titleId,
  ...props
}) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 9 16", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { fill: "currentColor", d: "M3.64 16h-.86l.86-6.22H0L5.35 0h.85l-.85 6.22H9z" }));
export {
  SvgBoltSharp as default
};
